import { render, staticRenderFns } from "./RolesPage.vue?vue&type=template&id=33afb246&scoped=true&"
import script from "./RolesPage.vue?vue&type=script&lang=js&"
export * from "./RolesPage.vue?vue&type=script&lang=js&"
import style0 from "./RolesPage.vue?vue&type=style&index=0&id=33afb246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33afb246",
  null
  
)

export default component.exports